import { Anchor } from "@omni/ui/components/Anchor/anchor.component";
import { Link } from "@omni/ui/components/CallToAction/types/link.types";
import { PropsWithChildren } from "react";

import { useCallToActionContext } from "../../callToAction.context";

type LinkCallToAcitonProps = PropsWithChildren<{
    link: Link;
}>;

const LinkCallToAction = (props: LinkCallToAcitonProps) => {
    const { link, children } = props;

    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <Anchor
            {...link}
            {...trackingProperties.click}
            {...styleProperties}
        >
            {children}
        </Anchor>
    );
};

export { LinkCallToAction };
